import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  signal,
} from "@angular/core";
import { MatToolbar } from "@angular/material/toolbar";

import { Link } from "../common/components/general/link/link";
import { ContentFilterPipe } from "../common/pipes/content-filter-pipe";
import { COMPONENT_META_DATA } from "../common/constants/component-meta-data";
import { FooterService } from "./footer.service";
import { FooterResult } from "./footer.model";
import { firstValueFrom } from "rxjs";

import { ReusableService } from "../common/services/reusable-services";
import { Router } from "@angular/router";
import { ApiResponse } from "../common/models/api-response.model";
import { MatTooltipModule } from "@angular/material/tooltip";

@Component({
  selector: "srp-footer",
  imports: [MatToolbar, Link, MatTooltipModule],
  templateUrl: "./footer.html",
  styleUrl: "./footer.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: "srp-app-wrapper" },
})
export class Footer implements OnInit {
  readonly footerService = inject(FooterService);
  readonly reusableService = inject(ReusableService);
  readonly router = inject(Router);
  build_version: any = "V1.2.1725";
  build_env: any = "dev";
  build_env_label: any = "Development";
  build_date: any = "04-November-2026 07:59 AM GMT";

  footerPageState = signal({
    pageContent: [],
    footerComponentLinks: []
  });

  languageCode: string = this.reusableService.getApplicableLanguage()?.languageCode ?? '';

  //  constructor() {}
  componentType: string = COMPONENT_META_DATA.FOOTER.VALUE;
  LABELS = COMPONENT_META_DATA.FOOTER.LABELS;

  ngOnInit(): void {
    void this.initializePage();
  }

  private async initializePage() {
    try {
      const response: ApiResponse<FooterResult> = await firstValueFrom(
        this.footerService.getFooter()
      );

      if (response?.data?.footer.length > 0) {
        this.footerPageState.set({
          pageContent: response.data.footer[0].labels,
          footerComponentLinks: response.data.footer[0].links
        });
      } else {
        console.error("Error fetching footer data:");
      }
    } catch (error) {
      console.error("Error fetching footer data:", error);
    }
  }
  onDocumentLinkClick(event: any, path: string, tab: string, tabTitle: string) {
    const currentUrl = window.location.origin;
    this.reusableService.navigateToLink(event, currentUrl, tab === 'newTab' ? '_blank' : '', path, this.router, tabTitle);
  }
}
